import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMemo, useEffect } from 'react';
import { ScreenReaderOnly } from 'foundations-components/transitional/components/ScreenReaderOnly';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { LeftIcon, RightIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ExpandIcon = props => {
  const IconComponent = useMemo(() => {
    return props.expanded ? LeftIcon : RightIcon;
  }, [props.expanded]);
  const tooltipText = useMemo(() => {
    return props.expanded ? 'customer-data-board.columnCollapse' : 'customer-data-board.columnExpand';
  }, [props.expanded]);
  useEffect(() => {
    return function cleanup() {
      if (props.onMouseLeave) {
        props.onMouseLeave();
      }
    };
  });
  return /*#__PURE__*/_jsxs(IconButton, {
    onMouseEnter: props.onMouseEnter,
    onMouseLeave: props.onMouseLeave,
    "aria-pressed": !props.expanded //button is pressed when column is collapsed
    ,
    size: "extra-small",
    placement: "top",
    onClick: props.onCollapse,
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: tooltipText
    }),
    "data-test-id": "cdb-column-expand-button",
    marginInlineStart: "0",
    marginInlineEnd: "0",
    children: [/*#__PURE__*/_jsx(IconComponent, {
      "data-test-id": `cdb-column-expand-icon-${props.expanded ? 'left' : 'right'}`
    }), /*#__PURE__*/_jsx(ScreenReaderOnly, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customer-data-board.columnCollapse"
      })
    })]
  });
};
export default ExpandIcon;